import { UserOffersQuery } from 'gql'
import { convertServerDateToClient, convertDate } from '~utils/time-new'

type BidDetailsType = {
  allOffers?: UserOffersQuery['currentUser']['offers']['edges']
  currentBid?: number
  purchaseStatus?: string
  start?: string
  end?: string
}

const getUserBiddingStatusOnArtwork = (bidDetails: BidDetailsType) => {
  const { allOffers, currentBid, purchaseStatus } = bidDetails
  const start = convertDate(bidDetails.start)
  const end = convertDate(bidDetails.end)

  const userWinningOffer = allOffers?.filter(({ node }) => node.isWinningBid)[0]?.node
  const userLastOffer = allOffers && allOffers[0]?.node

  const isEnded = new Date().getTime() > convertServerDateToClient(end).getTime()
  const willStart = new Date().getTime() < convertServerDateToClient(start).getTime()

  const userHasBidOnArtwork = userLastOffer?.bidType === 'BID'
  const isEnd = isEnded || purchaseStatus === 'sold'
  const userWon = userWinningOffer?.isWinningBid && isEnd
  const userHasPaid =
    userWinningOffer?.isWinningBid && userLastOffer?.paymentStatus === 'PAYMENT_PENDING'
  const userCurrentWinningOffer =
    userLastOffer?.price === currentBid || userLastOffer?.maxBidAmount > currentBid
  const isUserHighestBidder = !!userCurrentWinningOffer
  const isUserOutbid = userHasBidOnArtwork && !isUserHighestBidder
  const userMaxBidAmount = userCurrentWinningOffer && userLastOffer?.maxBidAmount
  const userHasMaxBid = userMaxBidAmount && userMaxBidAmount > currentBid

  return {
    userHasBidOnArtwork,
    isUserHighestBidder,
    isUserOutbid,
    isEnd,
    userHasMaxBid,
    userMaxBidAmount,
    userWon,
    winningBid: userWinningOffer?.price,
    userHasPaid,
    userLastOffer,
    willStart,
  }
}

export default getUserBiddingStatusOnArtwork
